var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-custom-scrollbar',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.removeMobileMnue),expression:"removeMobileMnue"}],staticClass:"navbar navbar-vertical fixed-left navbar-expand-md navbar-light",class:_vm.isActive ? 'active': '',attrs:{"settings":_vm.settings}},[_c('div',{staticClass:"container-fluid"},[_c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#sidebarCollapse","aria-controls":"sidebarCollapse","aria-expanded":"false","aria-label":"Toggle navigation"},on:{"click":_vm.toggleMobile}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#sidebarCollapse","aria-controls":"sidebarCollapse","aria-expanded":"false","aria-label":"Toggle navigation"},on:{"click":function($event){_vm.$parent.showMobileNave = !_vm.$parent.showMobileNave;
        _vm.$parent.showMobileMnue = false;}}},[(_vm.$user.admin || _vm.$user.role.profile_edit)?_c('router-link',{staticClass:"navbar-user-link nav-icon dropdown-toggle w-100",attrs:{"to":'/profile'}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"far fa-user"}),_vm._v(" "+_vm._s(_vm.$user.name)+" ")])]):_vm._e(),(!_vm.$user.admin && !_vm.$user.role.profile_edit)?_c('div',{staticClass:"navbar-user-link nav-icon dropdown-toggle w-100"},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"far fa-user"}),_vm._v(" "+_vm._s(_vm.$user.name)+" ")])]):_vm._e()],1),_c('div',{staticClass:"form-group has-search search-sidebar-style"},[_c('i',{staticClass:"fa fa-search form-control-feedback"}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchValue),expression:"searchValue"},{name:"click-outside",rawName:"v-click-outside",value:(_vm.removeSearch),expression:"removeSearch"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"بحث"},domProps:{"value":(_vm.searchValue)},on:{"keyup":function($event){return _vm.searchLink()},"focus":function($event){return _vm.searchLink()},"input":function($event){if($event.target.composing)return;_vm.searchValue=$event.target.value}}})]),_c('vue-custom-scrollbar',{staticClass:"collapse navbar-collapse",class:{ show: _vm.$parent.showMobileMnue },attrs:{"settings":_vm.settings2,"id":"sidebarCollapse"}},[(_vm.showSearchStat && _vm.selectedLinks.length != 0 )?_c('ul',{staticClass:"navbar-nav"},_vm._l((_vm.selectedLinks),function(link,index){return _c('singleItem',{key:index,attrs:{"to":link.link.substring(1),"icon":'far fa-file',"headname":link.name}})}),1):_vm._e(),(!_vm.showSearchStat || _vm.selectedLinks.length == 0)?_c('ul',{staticClass:"navbar-nav"},[_c('singleItem',{attrs:{"to":'',"icon":'far fa-tachometer-alt-fastest',"headname":_vm.$t('sidebar.dashboard')}})],1):_vm._e(),(!_vm.showSearchStat || _vm.selectedLinks.length == 0)?_c('hr',{staticClass:"navbar-divider my-3"}):_vm._e(),(!_vm.showSearchStat || _vm.selectedLinks.length == 0)?_c('ul',{staticClass:"navbar-nav"},[(
            (_vm.$site.customers_allow ||
              _vm.$site.quotations_allow ||
              _vm.$site.invoices_allow ||
              _vm.$site.saleReturns_allow ||
              _vm.$site.orders_allow ) &&
            (_vm.$user.admin ||
              _vm.$user.role.customers_show ||
              _vm.$user.role.quotations_show ||
              _vm.$user.role.invoices_show ||
              _vm.$user.role.sale_returns_show ||
              _vm.$user.role.orders_show)
          )?_c('multiItem',{attrs:{"icon":'far fa-chart-line',"headname":_vm.$t('sidebar.sales'),"items":[
            {
              name: _vm.$t('sidebar.customers'),
              link: '/customers',
              role:
                _vm.$site.customers_allow &&
                (_vm.$user.admin || _vm.$user.role.customers_show),
            },
            {
              name: _vm.$t('sidebar.estimates'),
              link: '/quotations',
              role:
                _vm.$site.quotations_allow &&
                (_vm.$user.admin || _vm.$user.role.quotations_show),
            },
            {
              name: _vm.$t('sidebar.salesInvoices'),
              link: '/invoices',
              role:
                _vm.$site.invoices_allow &&
                (_vm.$user.admin || _vm.$user.role.invoices_show),
            },
            {
              name: _vm.$t('sidebar.salesReturns'),
              link: '/saleReturns',
              role:
                _vm.$site.saleReturns_allow &&
                (_vm.$user.admin || _vm.$user.role.sale_returns_show),
            },
            {
              name: _vm.$t('sidebar.saleOrders'),
              link: '/orders',
              role:
                _vm.$site.orders_allow &&
                (_vm.$user.admin || _vm.$user.role.orders_show),
            },
          ]}}):_vm._e(),(
            (_vm.$site.suppliers_allow ||
              _vm.$site.bills_allow ||
              _vm.$site.purchaseReturns_allow ) &&
            (_vm.$user.admin ||
              _vm.$user.role.suppliers_show ||
              _vm.$user.role.bills_show ||
              _vm.$user.role.purchase_returns_show )
          )?_c('multiItem',{attrs:{"icon":'far fa-shopping-cart',"headname":_vm.$t('sidebar.purchases'),"items":[
            {
              name: _vm.$t('sidebar.suppliers'),
              link: '/suppliers',
              role:
                _vm.$site.suppliers_allow &&
                (_vm.$user.admin || _vm.$user.role.suppliers_show),
            },
            {
              name: _vm.$t('sidebar.bills'),
              link: '/bills',
              role:
                _vm.$site.bills_allow &&
                (_vm.$user.admin || _vm.$user.role.bills_show),
            },
            {
              name: _vm.$t('sidebar.purchaseReturns'),
              link: '/purchaseReturns',
              role:
                _vm.$site.purchaseReturns_allow &&
                (_vm.$user.admin || _vm.$user.role.purchase_returns_show),
            }
          ]}}):_vm._e(),(
            (_vm.$site.safes_allow ||
              _vm.$site.safesDeposits_allow ||
              _vm.$site.safesWithdrawals_allow ||
              _vm.$site.safesTransfers_allow ||
              _vm.$site.bankAccounts_allow ||
              _vm.$site.salesPayments_allow ||
              _vm.$site.purchasePayments_allow ||
              _vm.$site.expenses_allow ||
              _vm.$site.salesDiscounts_allow ||
              _vm.$site.purchaseDiscounts_allow) &&
            (_vm.$user.admin ||
              _vm.$user.role.safes_show ||
              _vm.$user.role.safes_deposits_show ||
              _vm.$user.role.safes_withdrawals_show ||
              _vm.$user.role.safes_transfers_show ||
              _vm.$user.role.bank_accounts_show ||
              _vm.$user.role.sales_payments_show ||
              _vm.$user.role.purchase_payments_show ||
              _vm.$user.role.expenses_show ||
              _vm.$user.role.sales_discounts_show ||
              _vm.$user.role.purchase_discounts_show)
          )?_c('multiItem',{attrs:{"icon":'far fa-treasure-chest',"headname":_vm.$t('sidebar.Safes'),"items":[
            {
              name: _vm.$t('sidebar.lockersList'),
              link: '/safes',
              role:
                _vm.$site.safes_allow &&
                (_vm.$user.admin || _vm.$user.role.safes_show),
            },
            {
              name: _vm.$t('sidebar.bankAccounts'),
              link: '/bankAccounts',
              role:
                _vm.$site.bankAccounts_allow &&
                (_vm.$user.admin || _vm.$user.role.bank_accounts__show),
            },
            {
              name: _vm.$t('sidebar.salePayments'),
              link: '/salesPayments',
              role:
                _vm.$site.salesPayments_allow &&
                (_vm.$user.admin || _vm.$user.role.sales_payments_show),
            },
            {
              name: _vm.$t('sidebar.purchasePayments'),
              link: '/purchasePayments',
              role:
                _vm.$site.purchasePayments_allow &&
                (_vm.$user.admin || _vm.$user.role.purchase_payments_show),
            },
            {
              name: _vm.$t('sidebar.Expenses'),
              link: '/expenses',
              role:
                _vm.$site.expenses_allow &&
                (_vm.$user.admin || _vm.$user.role.expenses_show),
            },
            {
              name: 'ايرادات',
              link: '/incomes',
              role:
                _vm.$site.expenses_allow &&
                (_vm.$user.admin || _vm.$user.role.expenses_show),
            },
            
            {
              name: _vm.$t('sidebar.Deposits'),
              link: '/safesDeposits',
              role:
                _vm.$site.safesDeposits_allow &&
                (_vm.$user.admin || _vm.$user.role.safes_deposits_show),
            },
            {
              name: _vm.$t('sidebar.Withdrawals'),
              link: '/safesWithdrawals',
              role:
                _vm.$site.safesWithdrawals_allow &&
                (_vm.$user.admin || _vm.$user.role.safes_withdrawals_show),
            },
            {
              name: _vm.$t('sidebar.Transfers'),
              link: '/safesTransfers',
              role:
                _vm.$site.safesTransfers_allow &&
                (_vm.$user.admin || _vm.$user.role.safes_transfers_show),
            },
            {
              name: _vm.$t('sidebar.salesDiscounts'),
              link: '/salesDiscounts',
              role:
                _vm.$site.salesDiscounts_allow &&
                (_vm.$user.admin || _vm.$user.role.sales_discounts_show),
            },
            {
              name: _vm.$t('sidebar.purchaseDiscounts'),
              link: '/purchaseDiscounts',
              role:
                _vm.$site.purchaseDiscounts_allow &&
                (_vm.$user.admin || _vm.$user.role.purchase_discounts_show),
            }
          ]}}):_vm._e(),(
            (_vm.$site.stores_allow ||
              _vm.$site.storesDeposits_allow ||
              _vm.$site.storesWithdrawals_allow ||
              _vm.$site.storesTransfers_allow) &&
            (_vm.$user.admin ||
              _vm.$user.role.stores_show ||
              _vm.$user.role.products_show ||
              _vm.$user.role.stores_deposits_show ||
              _vm.$user.role.stores_withdrawals_show ||
              _vm.$user.role.stores_transfers_show)
          )?_c('multiItem',{attrs:{"icon":'far fa-store-alt',"headname":_vm.$t('sidebar.stores'),"items":[
            {
              name: _vm.$t('sidebar.storesList'),
              link: '/stores',
              role:
                _vm.$site.stores_allow &&
                (_vm.$user.admin || _vm.$user.role.stores_show),
            },
            {
              name: _vm.$t('sidebar.productsAndServices'),
              link: '/products',
              role: _vm.$user.admin || _vm.$user.role.products_show,
            },
            {
              name: _vm.$t('sidebar.Deposits'),
              link: '/storesDeposits',
              role:
                _vm.$site.storesDeposits_allow &&
                (_vm.$user.admin || _vm.$user.role.stores_deposits_show),
            },
            {
              name: _vm.$t('sidebar.Withdrawals'),
              link: '/storesWithdrawals',
              role:
                _vm.$site.storesWithdrawals_allow &&
                (_vm.$user.admin || _vm.$user.role.stores_withdrawals_show),
            },
            {
              name: _vm.$t('sidebar.Transfers'),
              link: '/storesTransfers',
              role:
                _vm.$site.storesTransfers_allow &&
                (_vm.$user.admin || _vm.$user.role.stores_transfers_show),
            },
          ]}}):_vm._e(),(
            (_vm.$site.salesDiscounts_allow ||
              _vm.$site.purchaseDiscounts_allow) &&
            (_vm.$user.admin ||
              _vm.$user.role.sales_discounts_show ||
              _vm.$user.role.purchase_discounts_show)
          )?_c('multiItem',{attrs:{"icon":'far fa-badge-percent',"headname":_vm.$t('sidebar.Discounts'),"items":[
            {
              name: _vm.$t('sidebar.salesDiscounts'),
              link: '/salesDiscounts',
              role:
                _vm.$site.salesDiscounts_allow &&
                (_vm.$user.admin || _vm.$user.role.sales_discounts_show),
            },
            {
              name: _vm.$t('sidebar.purchaseDiscounts'),
              link: '/purchaseDiscounts',
              role:
                _vm.$site.purchaseDiscounts_allow &&
                (_vm.$user.admin || _vm.$user.role.purchase_discounts_show),
            },
          ]}}):_vm._e(),(
            (_vm.$site.manufacturingModels_allow ||
              _vm.$site.manufacturingOperations_allow) &&
            (_vm.$user.admin ||
              _vm.$user.role.manufacturing_models_show ||
              _vm.$user.role.manufacturing_operations_show)
          )?_c('multiItem',{attrs:{"icon":'far fa-hammer',"headname":_vm.$t('sidebar.ManufacturingProcesses'),"items":[
            {
              name: _vm.$t('sidebar.ManufacturingModels'),
              link: '/manufacturingModels',
              role:
                _vm.$site.manufacturingModels_allow &&
                (_vm.$user.admin || _vm.$user.role.manufacturing_models_show),
            },
            {
              name: _vm.$t('sidebar.OperationsList'),
              link: '/manufacturingOperations',
              role:
                _vm.$site.manufacturingOperations_allow &&
                (_vm.$user.admin || _vm.$user.role.manufacturing_operations_show),
            },
            {
              name: _vm.$t('sidebar.materialDeposit'),
              link: '/manufacturingDeposits',
              role:
                _vm.$site.manufacturingOperations_allow &&
                (_vm.$user.admin || _vm.$user.role.manufacturing_operations_show),
            },
            {
              name: _vm.$t('sidebar.productsWithdrawal'),
              link: '/manufacturingWithdrawals',
              role:
                _vm.$site.manufacturingOperations_allow &&
                (_vm.$user.admin || _vm.$user.role.manufacturing_operations_show),
            },
          ]}}):_vm._e(),(
            _vm.$site.cities_allow &&
            (_vm.$user.admin || _vm.$user.role.cities_show)
          )?_c('multiItem',{attrs:{"icon":'far fa-shipping-fast',"headname":_vm.$t('sidebar.Shipping'),"items":[
            { name: _vm.$t('sidebar.freightForwarders'), link: '/deliveries', role: true },
            {
              name: _vm.$t('sidebar.ListOfCities'),
              link: '/cities',
              role:
                _vm.$site.cities_allow &&
                (_vm.$user.admin || _vm.$user.role.cities_show),
            },
            {
              name: _vm.$t('sidebar.pickupLocations'),
              link: '/pickupLocations',
              role:
                _vm.$site.cities_allow &&
                (_vm.$user.admin || _vm.$user.role.cities_show),
            },
            {
              name: _vm.$t('sidebar.shippingOperations'),
              link: '/shippingOperations',
              role:
                _vm.$site.cities_allow &&
                (_vm.$user.admin || _vm.$user.role.cities_show),
            },
            {
              name: _vm.$t('sidebar.shippingAddresses'),
              link: '/shippingAddresses',
              role:
                _vm.$site.cities_allow &&
                (_vm.$user.admin || _vm.$user.role.cities_show),
            },
          ]}}):_vm._e(),(
            _vm.$site.pointOfSales_allow &&
            (_vm.$user.admin || _vm.$user.role.point_of_sales_show)
          )?_c('singleItem',{attrs:{"to":'pointOfSales',"icon":'far fa-cash-register',"headname":_vm.$t('sidebar.pointsOfSale')}}):_vm._e()],1):_vm._e(),(
          _vm.$site.reports_allow &&
          (_vm.$user.admin || _vm.$user.role.reports_show) &&
          (!_vm.showSearchStat || _vm.selectedLinks.length == 0)
        )?_c('ul',{staticClass:"navbar-nav"},[(_vm.$user.admin || _vm.$user.role.reports_show)?_c('singleItem',{attrs:{"to":'mainReport',"icon":'far fa-chart-bar',"headname":_vm.$t('sidebar.Reports')}}):_vm._e(),(_vm.$user.admin || _vm.$user.role.accounting_show)?_c('multiItem',{attrs:{"icon":'far fa-balance-scale',"headname":_vm.$t('sidebar.Accounting'),"items":[
            {
              name: _vm.$t('sidebar.ProfitsAndLosses'),
              link: '/profitsAndLosses',
              role: true,
            },
            {
              name: _vm.$t('sidebar.ProfitsByInvoices'),
              link: '/profitsByInvoices',
              role: true,
            },
            {
              name: _vm.$t('sidebar.dailyRestrictions'),
              link: '/dailyRestrictions',
              role: true,
            },
            { name: _vm.$t('sidebar.BalanceSheet'), link: '/totalReport', role: true },
          ]}}):_vm._e()],1):_vm._e(),(!_vm.showSearchStat || _vm.selectedLinks.length == 0)?_c('div',{staticClass:"mt-auto"}):_vm._e(),(!_vm.showSearchStat || _vm.selectedLinks.length == 0)?_c('ul',{staticClass:"navbar-nav"},[(_vm.$user.admin || _vm.$user.role.options_show)?_c('singleItem',{attrs:{"to":'options',"icon":'far fa-cog',"headname":_vm.$t('sidebar.settings')}}):_vm._e(),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link c-pointer",on:{"click":_vm.$logout}},[_c('i',{staticClass:"far fa-sign-out"}),_vm._v(" "+_vm._s(_vm.$t("sidebar.logout"))+" ")])])],1):_vm._e()])],1),_c('div',{staticClass:"sidebar-user"},[_c('router-link',{attrs:{"to":'/profile'}},[_c('div',{staticClass:"sidebar-user-flex"},[_c('div',{staticClass:"sidebar-user-img",style:(_vm.shownImage ? 'background-image: ' + _vm.shownImage + ';' : '')}),_c('div',{staticClass:"sidebar-user-info"},[_c('h3',[_vm._v(_vm._s(_vm.$user.name))]),_c('p',[_vm._v(_vm._s(_vm.$user.email))])])])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }